// 基准大小
export const baseSize = 14;
// 设置 rem 函数
export function setRem(screenWidth = 1440) {
    const scale = window.innerWidth / screenWidth;
    const desiredFontSize = baseSize * Math.min(scale, 2);
    const minFontSize = 12;
    const actualFontSize = Math.max(Math.min(desiredFontSize, 16), minFontSize);

    document.documentElement.style.fontSize = actualFontSize + 'px';

    // 安卓部分设备最小字体为12px，期望字体小于12px时用transform整体缩放补偿
    if (desiredFontSize < minFontSize) {
        const compensateScale = desiredFontSize / minFontSize;
        const sizeCompensation = 1 / compensateScale;
        document.body.style.transform = `scale(${compensateScale})`;
        document.body.style.transformOrigin = 'top left';
        document.body.style.width = `${100 * sizeCompensation}%`;
        document.body.style.height = `${100 * sizeCompensation}vh`;
        document.body.style.marginBottom = `${(compensateScale - 1) * 100}vh`;
        document.documentElement.style.height = '100vh';
    } else {
        document.body.style.transform = '';
        document.body.style.transformOrigin = '';
        document.body.style.width = '';
        document.body.style.height = '';
        document.body.style.marginBottom = '';
        document.documentElement.style.height = '';
    }
}
// 初始化
setRem();
// 改变窗口大小时重新设置 rem（节流，避免频繁计算）
let resizeTimer: ReturnType<typeof setTimeout> | null = null;
const throttleMs = 150;
window.addEventListener('resize', () => {
    if (resizeTimer) return;
    resizeTimer = setTimeout(() => {
        setRem();
        resizeTimer = null;
    }, throttleMs);
});
